import { Layout } from 'antd';
import styled, { css } from 'styled-components';

import { device } from 'styled';

const { Header } = Layout;

export const AvatarStyles = css`
  border: 2px solid #fff;
  box-shadow: 0 0 6px #f1f1f1;
  flex-shrink: 0;

  position: relative;

  &:hover {
    &::after {
      content: ' ';
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.25);

      border-radius: 50%;

      position: absolute;
      top: 0;
      left: 0;

      z-index: 1;
    }
  }
`;

export const Wrapper = styled(Header)`
  display: flex;
  height: 57px;
  justify-content: space-between;
  padding: 2px ${p => p.theme.app.padding.horizontal};
  align-items: center;
  background: #ffffff;

  top: 0;
  left: 0;
  z-index: 10;

  .ant-popover {
    padding-top: 4px !important;
  }

  .ant-dropdown {
    top: 63px !important;
    padding-top: 0px !important;
  }

  & .ant-dropdown-menu-item {
    padding: ${props =>
      `${props.theme.app.padding.vertical} ${props.theme.app.padding.horizontal}`};
  }

  @media ${device.lg} {
    & .ant-dropdown-arrow {
      right: 47px;
    }
  }
`;

export const WrapperShortcut = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  cursor: pointer;

  transition: all 0.4s;

  &:hover {
    .wrapper {
      background: ${props => `${props.theme.colors.primary.main}10`};
    }

    span {
      color: ${props => props.theme.colors.text.main};
    }

    path {
      fill: ${props => props.theme.colors.primary.main} !important;
    }
  }
`;

export const DivRow = styled.div`
  display: flex;
  width: auto;
  align-items: center;
`;

export const WrapperNotification = styled.div<{ active?: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  background: ${p =>
    p.active ? `${p.theme.colors.primary.main}10` : '#f1f1f1'};
  position: relative;

  &:hover {
    circle,
    path {
      fill: ${props => props.theme.colors.text.main} !important;
    }

    background: ${props => `${props.theme.colors.primary.main}10`};
  }

  circle,
  path {
    fill: ${props =>
      props.active
        ? props.theme.colors.text.main
        : props.theme.colors.text.primary} !important;
  }

  cursor: pointer;
`;

export const DivWrapper = styled.div`
  width: 260px;
`;

export const MenuItem = styled.li<{
  active: boolean;
  disabled: boolean;
}>`
  display: flex;
  align-items: center;
  padding: ${props =>
    `${props.theme.app.padding.vertical} ${props.theme.app.padding.horizontal}`};
  color: ${p => (p.active ? p.theme.colors.text.primary : null)};
  background: ${p =>
    p.active ? 'rgba(5, 182, 114, 0.05)' : 'rgba(5, 182, 114, 0)'};
  ${p =>
    !p.disabled &&
    `&:hover,
  &:focus {
    background: ${
      p.active ? 'rgba(5, 182, 114, 0.05)' : p.theme.colors.grey['50']
    };
  }`}
  border-radius: ${props => props.theme.radius.md};
  transition: color 0.5s;
  ${p => !p.disabled && 'cursor: pointer;'}
  .textMenu {
    transition: color 0.5s;
    color: ${p =>
      p.active ? 'rgba(5, 182, 114, 1)' : p.theme.colors.text.primary};
    overflow: hidden;
    white-space: nowrap;
  }
  .icon {
    & svg {
      width: 22px;
      height: 22px;
      ${p =>
        p.active
          ? `fill: rgba(5, 182, 114, 1)`
          : `fill: ${props => props.theme.colors.icon.secondary}`};
      path {
        ${p =>
          p.active
            ? `fill: rgba(5, 182, 114, 1)`
            : `fill: ${props => props.theme.colors.icon.secondary}`};
      }
    }
  }
`;
